import PropTypes from 'prop-types';
import React, { Component } from 'react';
import 'js/../stylesheets/user/mentions_settings.scss';
import _ from 'underscore';
import classNames from 'classnames';
import { Button } from 'js/design_system/Button';

// NATIONAL PARKS: Please remove this disable and try to fix it if you're here
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const defaultState = {
  firstName: {
    value: '',
    isValid: false,
    errorMessage: '',
  },
  middleName: {
    value: '',
    isValid: true,
    errorMessage: '',
  },
  lastName: {
    value: '',
    isValid: false,
    errorMessage: '',
  },
};

export class AddNameForm extends Component {
  constructor(props) {
    super(props);

    const initialState = {
      firstName: {
        value: this.props.initialFirstName,
        isValid: this.props.initialFirstName.length > 0,
        errorMessage: '',
      },
      middleName: {
        value: this.props.initialMiddleName,
        isValid: true,
        errorMessage: '',
      },
      lastName: {
        value: this.props.initialLastName,
        isValid: this.props.initialLastName.length > 0,
        errorMessage: '',
      },
    };
    this.state = initialState;
  }

  render() {
    const inputs = [
      {
        label: 'First Name',
        state: 'firstName',
        // Only the first box should have top padding
        classes: 'u-mh6x u-mt6x',
      },
      {
        label: this.props.middleInitials ? 'Middle Initials' : 'Middle Name',
        state: 'middleName',
        classes: 'u-mh6x',
      },
      {
        label: 'Last Name',
        state: 'lastName',
        classes: 'u-mh6x',
      },
    ];

    return (
      <div className="DesignSystem add-name-form-box u-border1 u-borderColorGrayLight u-bgColorWhite">
        {_.map(inputs, (input, index) => {
          const inputClasses = classNames(
            'TextInput TextInput--lg u-fw400 u-fs14 u-lineHeight1_1 name-input',
            {
              // Make the box red if and only if an error message is displayed
              'TextInput--error': this.state[input.state].errorMessage,
              'u-mt3x': !this.props.modalMode,
            },
          );
          // Note: last name error spot also displays server errors
          let errorMsg = null;
          if (this.state[input.state].errorMessage) {
            errorMsg = this.state[input.state].errorMessage;
            // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
            // eslint-disable-next-line eqeqeq
          } else if (this.props.errorMessage && index == 2) {
            errorMsg = this.props.errorMessage;
          }
          return (
            <div className={input.classes} key={index}>
              <input
                type="text"
                id={input.state}
                className={inputClasses}
                placeholder={input.label}
                value={this.state[input.state].value}
                onChange={this.updateAndValidateFields}
              />
              <label className="u-mb0x">
                {errorMsg ? (
                  <span className="u-tcRed u-fs14 u-fw400 u-lineHeight1_1">
                    {errorMsg}
                  </span>
                ) : (
                  <br />
                )}
              </label>
            </div>
          );
        })}
        <div className="cta-wrapper">
          <Button secondary onClick={this.props.onCancel}>
            CANCEL
          </Button>
          <Button onClick={this.confirm} disabled={this.buttonDisabled()}>
            {this.props.buttonText}
          </Button>
        </div>
      </div>
    );
  }

  buttonDisabled = () => {
    return !(
      this.state.firstName.isValid &&
      this.state.middleName.isValid &&
      this.state.lastName.isValid
    );
  };

  setNameFieldState = (id, value, errorMessage) => {
    const state = {};
    state['value'] = value;
    state['errorMessage'] = errorMessage;
    state['isValid'] = errorMessage.length === 0;
    this.setState({ [id]: state });
  };

  updateAndValidateFields = (e) => {
    // Clear server add name errors as soon as user types
    this.props.onClearAddNameErrors();

    const { value, id } = e.target;
    let errorMessage = '';

    if (id !== 'middleName' && value.trim().length < 2) {
      errorMessage = 'Must be at least 2 characters';
    } else if (value.trim().length > 100) {
      errorMessage = 'Can not be longer than 100 characters';
    }
    this.setNameFieldState(id, value, errorMessage);
  };

  confirm = () => {
    const { firstName, middleName, lastName } = this.state;
    this.props.onAdd(firstName.value, middleName.value, lastName.value);
  };
}
AddNameForm.propTypes = {
  buttonText: PropTypes.string.isRequired,
  onAdd: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClearAddNameErrors: PropTypes.func.isRequired,
  errorMessage: PropTypes.any,
  middleInitials: PropTypes.bool,
  modalMode: PropTypes.bool,
  initialFirstName: PropTypes.string,
  initialMiddleName: PropTypes.string,
  initialLastName: PropTypes.string,
};
AddNameForm.defaultProps = {
  middleInitials: false,
  modalMode: false,
  initialFirstName: '',
  initialMiddleName: '',
  initialLastName: '',
};

export default AddNameForm;
